export const variantPropMap = {
  filled: {
    variant: 'contained',
    className: 'button--filled',
    isLoadingClassName: 'button--filled--loading',
    isSuccessClassName: 'button--filled--success'
  },
  filledV2: {
    variant: 'contained',
    className: 'button--filled-v2',
    isLoadingClassName: 'button--filled-v2--loading',
    isSuccessClassName: 'button--filled-v2--success'
  },
  outlined: {
    variant: 'outlined',
    className: 'button--outlined',
    isLoadingClassName: 'button--outlined--loading',
    isSuccessClassName: 'button--outlined--success'
  },
  outlinedV2: {
    variant: 'outlined',
    className: 'button--outlined-v2',
    isLoadingClassName: 'button--outlined-v2--loading',
    isSuccessClassName: 'button--outlined-v2--success'
  },
  text: {
    variant: 'text',
    className: 'button--text',
    isLoadingClassName: 'button--text--loading',
    isSuccessClassName: ''
  },
  textV2: {
    variant: 'text',
    className: 'button--text-v2',
    isLoadingClassName: 'button--text-v2--loading',
    isSuccessClassName: 'button--text-v2--success'
  },
  elevated: {
    variant: 'contained',
    className: 'button--elevated',
    isLoadingClassName: 'button--elevated--loading',
    isSuccessClassName: 'button--elevated--success'
  },
  tonal: {
    variant: 'contained',
    className: 'button--tonal',
    isLoadingClassName: 'button--tonal--loading',
    isSuccessClassName: 'button--tonal--success'
  },
  tonalV2: {
    variant: 'contained',
    className: 'button--tonal-v2',
    isLoadingClassName: 'button--tonal-v2--loading',
    isSuccessClassName: 'button--tonal-v2--success'
  },
  navigation: {
    variant: 'contained',
    className: 'button--navigation',
    isLoadingClassName: 'button--navigation--loading',
    isSuccessClassName: ''
  }
};

export const sizeMap = {
  small: {
    className: 'button--small'
  },
  medium: {
    className: 'button--medium'
  },
  large: {
    className: 'button--large'
  },
  smallV2: {
    className: 'button--small-v2'
  },
  mediumV2: {
    className: 'button--medium-v2'
  },
  largeV2: {
    className: 'button--large-v2'
  },
  xlargeV2: {
    className: 'button--xlarge-v2'
  }
};
